module.exports = __webpack_public_path__ + "img/back.421929e8.png";